module.exports = __webpack_public_path__ + "media/2021炉料120s.87fbf3fc.mp4";